<template>
    <PatientProfile
        :patientId    = "patientInfo.id"
        :name         = "patientInfo.name"
        :birth        = "patientInfo.birth"
        :age          = "patientInfo.age"
        :weight       = "patientInfo.weight"
        :lastExam     = "patientInfo.lastExam"
        :painArea     = "patientInfo.painArea"
        :showPainArea = "true"
    />
    <hr style="border:0; border-top:1.5px solid #c8c8c8; margin:12px 0;" />
    <!-- <div> -->
        <div class="treatment-page mb30">
            <!-- 왼쪽: 인체 부위 및 제어 -->
            <div class="treatment-left">
<!--                <div class="body-label"><b>| 통증 부위</b></div>-->
<!--                <div class="body-figure">-->
<!--                    <img src="@/assets/resource/icon/body-base-img.svg" class="body-img"/>-->
<!--                    <div v-for="loc in diagnosis.locations ?? []" :key="loc" class="pain-area-marker" :style="getPainAreaMarkerStyle(loc)"></div>-->
<!--                </div>-->
                <div class="pair-mode-title">Pair {{ currentRunningPair ?? '-' }} 모드</div>
                <div class="slider-row">
                    <span>{{ formatTime(totalElapsedMs) }}</span>
                    <input
                        type="range"
                        min="0"
                        max="100"
                        step="any"
                        :value="sliderPercentage"
                        class="slider"
                        style="pointer-events: none;"
                    />
                    <span>{{ formatTime(totalTimeMs) }}</span>
                </div>
                <div class="btn-row">
                    <button class="btn start" @click="startTimerForCurrentPair" :disabled="state == 'start' && count < 1">
                        <span style="margin-right:5px;">&#9654;</span> START
                    </button>
                    <button class="btn pause" @click="pauseTimer" :disabled="state != 'start' && count < 1">
                        <svg width="16" height="16" viewBox="0 0 16 16">
                            <rect x="2" y="2" width="4" height="12"/>
                            <rect x="10" y="2" width="4" height="12"/>
                        </svg> PAUSE
                    </button>
                    <button class="btn stop" @click="stopAllTimer" :disabled="(state == '' || state == 'stop') && count < 1">
                        <svg width="16" height="16" viewBox="0 0 16 16">
                            <rect x="3" y="3" width="10" height="10"/>
                        </svg> STOP
                    </button>
                </div>
            </div>
            <!-- 오른쪽: 두 개의 표 -->
            <div class="treatment-tables">
                <table class="treatment-table">
                    <colgroup>
                        <col style="width: 7%" />
                        <col style="width: 10%" />
                        <col style="width: 10%" />
                        <col style="width: 10%" />
                        <col style="width: auto" />
                        <col style="width: auto" />
                        <col style="width: auto" />
                        <col style="width: 12%" />
                    </colgroup>
                    <thead>
                        <tr>
                            <th>Pair</th>
                            <th>F1(Hz)</th>
                            <th>I(μA)</th>
                            <th>T(m'm)</th>
                            <th>Period(ms)</th>
                            <th>Polarity</th>
                            <th>Wave-Form</th>
                            <th>완료여부</th>
                        </tr>
                    </thead>
                    <tbody>
                        <!-- 예시: 10행 반복 -->
                        <tr v-for="(item, index) in treatmentTableLeft" :key="index" :class="{running: currentRunningPair === Number(item.pair) && count < 1,completed: item.completed === true || item.completed === 'Y'}">
                            <td>{{ item.pair }}</td>
                            <td>{{ item.f1 }}</td>
                            <td>{{ item.i }}</td>
                            <td>{{ item.t }}</td>
                            <td>{{ item.period }}</td>
                            <td>{{ changePolarity(item) }}</td>
                            <td>{{ item.waveForm }}</td>
                            <td>{{ item.completed ? 'Y' : 'N' }}</td>
                        </tr>
                    </tbody>
                </table>
                <table class="treatment-table">
                    <colgroup>
                        <col style="width: 7%" />
                        <col style="width: 10%" />
                        <col style="width: 10%" />
                        <col style="width: 10%" />
                        <col style="width: auto" />
                        <col style="width: auto" />
                        <col style="width: auto" />
                        <col style="width: 12%" />
                    </colgroup>
                    <thead>
                        <tr>
                            <th>Pair</th>
                            <th>F2(Hz)</th>
                            <th>I(μA)</th>
                            <th>T(m'm)</th>
                            <th>Period(ms)</th>
                            <th>Polarity</th>
                            <th>Wave-Form</th>
                            <th>완료여부</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, index) in treatmentTableRight" :key="index" :class="{running: currentRunningPair === Number(item.pair) && count < 1,completed: item.completed === true || item.completed === 'Y'}">
                            <td>{{ item.pair }}</td>
                            <td>{{ item.f2 }}</td>
                            <td>{{ item.i }}</td>
                            <td>{{ item.t }}</td>
                            <td>{{ item.period }}</td>
                            <td>{{ changePolarity(item) }}</td>
                            <td>{{ item.waveForm }}</td>
                            <td>{{ item.completed ? 'Y' : 'N' }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    <!-- </div> -->
</template>
<script setup>
    defineOptions({
        meta: {
            title: '프로토콜 실행',
            segmentKey: 'patientId'
        }
    })
    import PatientProfile           from "@/components/common/PatientProfile.vue"
    import {useRoute, useRouter}    from "vue-router";
    import {onMounted, ref,computed, onBeforeUnmount, inject } from "vue";
    import api, { urls }    from "@/api";
    import { convertUtils } from '@/utils/convertUtils'
    import { commonUtils }  from "@/utils/commonUtils";
    import {useAuthStore}   from "@/stores/auth";
    import { useAppAlert }  from '@/composables/useAppAlert'

    const { showAlert, confirm }      = useAppAlert()

    // BLE 상태와 액션 주입
    const bleState   = inject('bleState')
    const bleActions = inject('bleActions')

    // 충전상태
    const isCharging = ref(false)

    const count      = ref(0)
    const ctrl1Count = ref(0)
    const ctrl2Count = ref(0)
    const startCount = ref(0)
    const stopCount  = ref(0)
    const state      = ref('')
    const startFlag  = ref('')
    const pair       = ref(null)
    const ch1Noraml  = ref(false)
    const ch2Noraml  = ref(false)

    const route               = useRoute()
    const router              = useRouter()
    const patientInfo         = ref({})
    const diagnosis           = ref({})
    const treatmentTableLeft  = ref([]);
    const treatmentTableRight = ref([]);
    const currentRunningPair  = ref(null);
    const elapsedTimeMs       = ref(0);       // 누적 총 시간
    const pairElapsedMs       = ref(0);       // 현재 페어 내 시간

    const totalElapsedMs = computed(() => elapsedTimeMs.value + pairElapsedMs.value);

    let timerInterval = null;

    // 추가
    let animationFrameId    = null;
    let pairStartTimestamp  = 0;
    let pairBaseElapsedMs   = 0;

    const pairRandom  = ref(false);  // 초기값은 순차 실행(기본)

    const executionOrder    = ref([]);  // 실행 순서용 배열 (페어 번호 리스트)
    const currentExecIndex  = ref(0);
    const prescriptionId    = ref(null);

    const baseFrontRaw = [
        //앞쪽
        { cx: 70, cy: 42 },   // 목
        { cx: 44, cy: 66 },   // 좌측 어깨
        { cx: 34, cy: 101 },   // 좌측 상완
        { cx: 32, cy: 139 },   // 좌측 팔꿈치
        { cx: 17, cy: 174 },   // 좌측 손
        { cx: 48, cy: 163 },   // 좌측 골반
        { cx: 54, cy: 210 },   // 좌측 허벅지
        { cx: 56, cy: 280 },   // 좌측 종아리
        { cx: 60, cy: 329 },   // 좌측 발

        { cx: 94, cy: 66 },   // 우측 어깨
        { cx: 108, cy: 101 },   // 우측 상완
        { cx: 111, cy: 139 },   // 우측 팔꿈치
        { cx: 125, cy: 174 },   // 우측 손
        { cx: 94, cy: 163 },   // 우측 골반
        { cx: 88, cy: 210 },   // 우측 허벅지
        { cx: 86, cy: 280 },   // 우측 종아리
        { cx: 81, cy: 329 },   // 우측 발

        { cx: 72, cy: 99 },   // 가슴 중앙
        { cx: 72, cy: 127 },   // 배

        //뒤쪽
        { cx: 230, cy: 42 },   // 목
        { cx: 204, cy: 66 },   // 좌측 어깨
        { cx: 194, cy: 101 },   // 좌측 상완
        { cx: 192, cy: 139 },   // 좌측 팔꿈치
        { cx: 177, cy: 174 },   // 좌측 손
        { cx: 208, cy: 163 },   // 좌측 골반
        { cx: 214, cy: 210 },   // 좌측 허벅지
        { cx: 216, cy: 280 },   // 좌측 종아리
        { cx: 220, cy: 329 },   // 좌측 발

        { cx: 254, cy: 66 },   // 우측 어깨
        { cx: 268, cy: 101 },   // 우측 상완
        { cx: 271, cy: 139 },   // 우측 팔꿈치
        { cx: 285, cy: 174 },   // 우측 손
        { cx: 254, cy: 163 },   // 우측 골반
        { cx: 248, cy: 210 },   // 우측 허벅지
        { cx: 246, cy: 280 },   // 우측 종아리
        { cx: 241, cy: 329 },   // 우측 발

        { cx: 232, cy: 99 },   // 가슴 중앙
        { cx: 232, cy: 127 },   // 배

    ];

    const frontAreaLabels = [
        // 앞쪽
        '(앞쪽) 목',
        '(앞쪽) 좌측 어깨',
        '(앞쪽) 좌측 상완',
        '(앞쪽) 좌측 팔꿈치',
        '(앞쪽) 좌측 손',
        '(앞쪽) 좌측 골반',
        '(앞쪽) 좌측 허벅지',
        '(앞쪽) 좌측 종아리',
        '(앞쪽) 좌측 발',

        '(앞쪽) 우측 어깨',
        '(앞쪽) 우측 상완',
        '(앞쪽) 우측 팔꿈치',
        '(앞쪽) 우측 손',
        '(앞쪽) 우측 골반',
        '(앞쪽) 우측 허벅지',
        '(앞쪽) 우측 종아리',
        '(앞쪽) 우측 발',

        '(앞쪽) 가슴 중앙',
        '(앞쪽) 배',

        // 뒤쪽
        '(뒤쪽) 목',
        '(뒤쪽) 좌측 어깨',
        '(뒤쪽) 좌측 상완',
        '(뒤쪽) 좌측 팔꿈치',
        '(뒤쪽) 좌측 손',
        '(뒤쪽) 좌측 골반',
        '(뒤쪽) 좌측 허벅지',
        '(뒤쪽) 좌측 종아리',
        '(뒤쪽) 좌측 발',

        '(뒤쪽) 우측 어깨',
        '(뒤쪽) 우측 상완',
        '(뒤쪽) 우측 팔꿈치',
        '(뒤쪽) 우측 손',
        '(뒤쪽) 우측 골반',
        '(뒤쪽) 우측 허벅지',
        '(뒤쪽) 우측 종아리',
        '(뒤쪽) 우측 발',

        '(뒤쪽) 가슴 중앙',
        '(뒤쪽) 배'
    ];

    const totalTimeMs = computed(() => {
        const total = treatmentTableLeft.value.reduce((sum, item) => sum + ((item.t || 0) * 60 * 1000), 0);
        return total;
    });

    function getPainAreaMarkerStyle(locations) {
        // 부위명 → 인덱스 찾고, 좌표 변환
        const idx = frontAreaLabels.indexOf(locations);
        if (idx === -1) {
            return {
                top: '100px',
                left: '150px'
            };
        }
        return {
            top: frontAreas[idx].top,
            left: frontAreas[idx].left
        };
    }

    const frontAreas = baseFrontRaw.map(p => ({
        ...p,
        top: (p.cy / 338 * 100).toFixed(2) + '%',
        left: (p.cx / 301 * 100).toFixed(2) + '%'
    }));

    const handleDisconnected = (e) => {
        clearAllIntervals();

        // elapsedTimeMs.value = 0;
        // pairElapsedMs.value = 0;
        // currentExecIndex.value = 0;
        // currentRunningPair.value = 0;
        count.value = 0;
        state.value = 'pause';
        startFlag.value = '';

        // treatmentTableLeft.value.forEach(item => item.completed = false);
        // treatmentTableRight.value.forEach(item => item.completed = false);

        window.dispatchEvent(new CustomEvent('prescription-running', {detail: {running: false}}));

        showAlert("BLE 연결이 해제되어 일시정지되었습니다.\n재연결 후 START를 누르면 이어서 진행됩니다.");
        recordMeasurementEvent('bleDisconnected', {reason: e?.detail?.reason || 'unknown'}, 'R');
    };

    const handleBatteryStatusChanged = (event) => {
        isCharging.value = !!event.detail?.isCharging
    }

    async function PatientData(id,prescriptionId) {
        try {
            const params = {
                id: id,
                prescriptionId: prescriptionId
            };

            const ps = await api.post(urls.patientList.prescription, params);
            const prescriptionData = ps.data.list ? ps.data.list[0] : {};

            const res = await api.post(urls.patientList.patientData, params);
            const data = res.data.list ? res.data.list[0] : res.data;
            // [1] 환자 프로필용 데이터
            patientInfo.value = {
                id: data.patient_id,
                name: data.name,
                birth: data.dob || '',
                age: commonUtils.calcAge(data.dob),
                weight: data.weight,
                lastExam: data.created_at ? data.created_at.split('T')[0] : '',
                painArea: data.pain_area || ''
            };
            // [2] 진단 데이터 (템플릿 metrics 부분에서 사용)
            diagnosis.value = {
                cpt: data.cpt_mean || 0,
                pec: data.pec_mean || 0,
                score: data.score || 0,
                vas: data.vas_score || 0,
                location: prescriptionData.pain_area || '',
                locations: prescriptionData.pain_area
                    ? prescriptionData.pain_area.split(',').map(s => s.trim())
                    : [],
                comment: data.comment || ''
            };
        } catch (err) {
            showAlert("환자 정보 불러오는데 실패했습니다.");
        }
    }

    async function fetchTreatmentData(patientId,prescriptionId) {
        const params = { patientId,prescriptionId };
        const res    = await api.post(urls.patientList.treatmentData, params);

        if (res.data.list.length > 0) {
            pairRandom.value = res.data.list[0].pair_random;  // true or false
        } else {
            pairRandom.value = false; // 기본값
        }

        applyTreatmentData(res.data.list);
        prepareExecutionOrder();
    }

    const changePolarity = (val) => {
        return val.polarity == 1 ? '+ 방향' : val.polarity == 2 ? '- 방향' : val.polarity == 3 ? '양방향' : val.polarity
    }

    function applyTreatmentData(dataList) {
        if (!dataList.length) {
            treatmentTableLeft.value = [];
            treatmentTableRight.value = [];
            return;
        }

        const sortedLeft = dataList
            .filter(i => i.channel === 'Ch1')
            .map(itemToRow)
            .sort((a, b) => a.pair - b.pair);

        const sortedRight = dataList
            .filter(i => i.channel === 'Ch2')
            .map(itemToRow)
            .sort((a, b) => a.pair - b.pair);

        treatmentTableLeft.value  = sortedLeft;
        treatmentTableRight.value = sortedRight;
    }

    function itemToRow(item) {
        return {
            pair: item.pair_no,
            f1: item.channel === 'Ch1' ? item.freq_hz : '',
            f2: item.channel === 'Ch2' ? item.freq_hz : '',
            i: item.amp_ua,
            t: item.t_ms ? Math.ceil(item.t_ms / 60) : 0,  // 초 → 분으로 변환 후 올림 처리
            period: item.period_ms,
            polarity: item.polarity,
            waveForm: item.wave_form,
            completed: item.completed || '' // 필요시 조정
        };
    }

    const formatTime = (ms) => {
        if (typeof ms !== 'number' || isNaN(ms) || ms < 0) {
            ms = 0;
        }
        const totalSeconds  = Math.floor(ms / 1000);
        const minutes       = Math.floor(totalSeconds / 60);
        const seconds       = totalSeconds % 60;
        const formatted     = `${String(minutes).padStart(2,'0')}:${String(seconds).padStart(2,'0')}`;
        return formatted;
    }

    function startSmoothProgressTimer(maxTime, onComplete) {
        cancelSmoothProgressTimer();

        // pause 후 다시 시작하면 기존 진행 시간부터 이어감
        pairBaseElapsedMs = pairElapsedMs.value;
        pairStartTimestamp = performance.now();

        const tick = (now) => {
            const elapsedSinceStart = now - pairStartTimestamp;
            const nextElapsed = Math.min(pairBaseElapsedMs + elapsedSinceStart, maxTime);

            pairElapsedMs.value = nextElapsed;

            if (nextElapsed >= maxTime) {
                cancelSmoothProgressTimer();
                onComplete?.();
                return;
            }

            animationFrameId = requestAnimationFrame(tick);
        };

        animationFrameId = requestAnimationFrame(tick);
    }

    function cancelSmoothProgressTimer() {
        if (animationFrameId !== null) {
            cancelAnimationFrame(animationFrameId);
            animationFrameId = null;
        }
    }

    function pauseTimer() {
        if(!bleState.deviceConnected.value && !bleState.isReady.value && bleState?.deviceConnected?.value){
            showAlert('장비가 연결되어 있지 않거나 통신 준비가 되지 않았습니다.')
            return
        }

        if(timerInterval) {
            clearInterval(timerInterval);
            timerInterval = null;
        }

        const currentPairNo = currentRunningPair.value;
        clearAllIntervals();
        state.value     = 'pause'
        startFlag.value = ''
        sendTreatmentMessage(currentPairNo,0,"PAUSE");  // 정지 시 BLE 메시지 전송
    }

    async function stopAllTimer() {
        const ok = await confirm("현재 실행 중인 프로토콜을 종료하시겠습니까?");
        if (!ok) return;

        elapsedTimeMs.value     = 0;
        pairElapsedMs.value     = 0;
        currentExecIndex.value  = 0;

        stopTimer();

        // 실행 종료 상태를 Header에 알림
        window.dispatchEvent(new CustomEvent('prescription-running', { detail: { running: false } }))
    }

    function clearAllIntervals() {
        if (timerInterval) {
            clearInterval(timerInterval);
            timerInterval = null;
        }

        cancelSmoothProgressTimer();

        if (intervalArray && intervalArray.length > 0) {
            intervalArray.forEach(id => clearInterval(id));
            intervalArray.length = 0;
        }
        // state.value = '';

    }

    function stopTimer() {
        if(!bleState.deviceConnected.value && !bleState.isReady.value){
            showAlert('장비가 연결되어 있지 않거나 통신 준비가 되지 않았습니다.')
            return
        }

        clearAllIntervals();

        const currentPairNo = currentRunningPair.value;
        state.value     = 'stop'
        startFlag.value = ''
        sendTreatmentMessage(currentPairNo,0,"STOP");  // 정지 시 BLE 메시지 전송
    }

    function startTimerForCurrentPair() {
        if (isCharging.value) {
            showAlert('충전 중에는 프로토콜을 실행할 수 없습니다.')
            return
        }

        startFlag.value = 'Y'

        if(!bleState.deviceConnected.value || !bleState.isReady.value){
            showAlert('장비가 연결되어 있지 않거나 통신 준비가 되지 않았습니다.')
            return
        }


        count.value++;

        // 중복 실행 방지: count가 1 이상이면 함수 종료
        if(count.value !== 1) {
            return;
        }

        if (state.value !== 'start' || currentRunningPair.value !== null){
            if (timerInterval) {
                clearInterval(timerInterval);
                timerInterval = null;
            }
            if (!executionOrder.value.length) return;

            // Pause 후 재시작인 경우 현재 페어 유지, 아니면 새로운 페어 시작
            let currentPairNo;
            if (state.value === 'pause' && currentRunningPair.value !== null) {
                // Pause 상태에서 재시작: 현재 페어 계속 진행
                currentPairNo = currentRunningPair.value;
            } else {
                // 새로 시작하거나 다음 페어로 이동
                currentPairNo = executionOrder.value[currentExecIndex.value];
                currentRunningPair.value = currentPairNo;
                pairElapsedMs.value = 0;  // 새 페어 시작 시에만 초기화
            }
            state.value = 'start'
            window.dispatchEvent(new CustomEvent('prescription-running', { detail: { running: true } }))

            pair.value = treatmentTableLeft.value.find(p => p.pair === currentPairNo);
            if (!pair.value) return;

            if (currentExecIndex.value !== 0) { // 처음 시작 아닐 때만 PAUSE
                recordMeasurementEvent("PAUSE",currentRunningPair.value,'T')
            }
            sendTreatmentMessage(currentPairNo, 1, "START");
            count.value--;
            //
            // const retryInterval = setInterval(() => {
            //     if(count.value === 1){
            //         sendTreatmentMessage(currentPairNo, 1);
            //     }
            // }, 200);
            //
            // setTimeout(() => {
            //     clearInterval(retryInterval);
            //     count.value--;
            //     bleActions.enableBack();
            // }, 1050);

        }
    }

    function finishPair(pairNo) {
        const pairLeft  = treatmentTableLeft.value.find(i => i.pair === pairNo);
        const pairRight = treatmentTableRight.value.find(i => i.pair === pairNo);
        if (pairLeft) pairLeft.completed = true;
        if (pairRight) pairRight.completed = true;
    }

    function shuffleArray(array) {
        const arr = array.slice(); // 복사본 생성
        for (let i = arr.length -1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i+1));
            [arr[i], arr[j]] = [arr[j], arr[i]];
        }
        return arr;
    }

    function prepareExecutionOrder() {
        const pairs = treatmentTableLeft.value.map(p => p.pair);
        if (pairRandom.value) {
            executionOrder.value = shuffleArray(pairs);
        } else {
            executionOrder.value = pairs.slice(); // 순차 복제
        }
        currentExecIndex.value = 0;
    }

    function setElapsedBySlider(value) {
        const targetSeconds = Number(value);
        const targetMs      = targetSeconds * 1000;
        
        // 타이머가 실행 중이면 중지
        const wasRunning = timerInterval !== null;
        if (wasRunning) {
            clearInterval(timerInterval);
            timerInterval = null;
        }
        
        // 슬라이더로 이동한 시간에 해당하는 페어 찾기
        let accumulatedMs  = 0;
        let foundPairIndex = -1;
        
        for (let i = 0; i < executionOrder.value.length; i++) {
            const pairNo = executionOrder.value[i];
            pair.value = treatmentTableLeft.value.find(p => p.pair === pairNo);
            if (!pair.value) continue;
            
            const pairDuration = pair.value.t * 60 * 1000;
            
            if (targetMs < accumulatedMs + pairDuration) {
                foundPairIndex           = i;
                elapsedTimeMs.value      = accumulatedMs;
                pairElapsedMs.value      = targetMs - accumulatedMs;
                currentExecIndex.value   = i;
                currentRunningPair.value = pairNo;
                break;
            }
            
            accumulatedMs += pairDuration;
        }
        
        // 슬라이더가 끝까지 간 경우
        if (foundPairIndex === -1) {
            elapsedTimeMs.value      = totalTimeMs.value;
            pairElapsedMs.value      = 0;
            currentExecIndex.value   = executionOrder.value.length;
            currentRunningPair.value = null;
        }
        
        // 실행 중이었다면 다시 시작
        if (wasRunning && currentRunningPair.value !== null) {
            startTimerForCurrentPair();
        }
    }

    const sliderPercentage = computed(() => {
        const totalMs = totalTimeMs.value;
        const currentMs = totalElapsedMs.value;

        if (totalMs <= 0) return 0;
        if (currentMs >= totalMs) return 100;

        return (currentMs / totalMs) * 100;
    });


    function sendTreatmentMessage(pairNo, startStop, status) {
        const type      = 'T';
        const pairLeft  = treatmentTableLeft.value.find(p => p.pair === pairNo);
        const pairRight = treatmentTableRight.value.find(p => p.pair === pairNo);

        // 채널별 메세지 생성
        const makeMsg = (gubun, category, st = 0, item) => {
            const waveDirection = item.polarity || 3;               // 미정은 양방향(3) 기본
            const currentUa     = Math.ceil(item.i / 10) || 10;     // 기본 100μA
            const periodMs      = item.period || 500;               // 기본 500ms
            const highMs        = Math.floor(periodMs / 256);
            const lowMs         = periodMs % 256; 
            const carrierHz     = item.f1 || item.f2 || 100;        // 기본 100Hz
            const highHz        = Math.floor(carrierHz / 256);
            const lowHz         = carrierHz % 256;
            const { rampUp, peak, rampDown, off } = getWaveFormParams(item.waveForm);

            let result

            if(category == 2){
                result = convertUtils.generateBLEArray(gubun, category, waveDirection, currentUa, highMs, lowMs, highHz, lowHz, off, rampUp, peak, rampDown)
            }else{
                result = convertUtils.generateBLEArray(gubun, category, st)
            }

            recordMeasurementEvent(status,{ measurementValues: result },type)
            return result
        };

        if(startStop > 0){
            const ch1 = makeMsg(2, 2, undefined, pairLeft)
            bleActions.sendMessage(ch1)
            ctrl1Count.value = 1

            // 무응답 시 추가
            const retryInterval = setInterval(() => {
                if(ctrl1Count.value > 0){
                    const retry = makeMsg(2, 2, undefined, pairLeft)
                    bleActions.sendMessage(retry)
                }
            }, 200)
            setTimeout(() => {
                if (retryInterval) {
                    clearInterval(retryInterval);
                    bleActions.enableBack()
                }
            }, 1050);

            setTimeout(() => {
                const ch2 = makeMsg(3, 2, undefined, pairRight)
                bleActions.sendMessage(ch2)
                ctrl2Count.value = 1

                // 무응답 시 추가
                const retry2Interval = setInterval(() => {
                    if(ctrl2Count.value > 0){
                        const retry = makeMsg(3, 2, undefined, pairRight)
                        bleActions.sendMessage(retry)
                    }
                }, 200)
                setTimeout(() => {
                    if (retry2Interval) {
                        clearInterval(retry2Interval);
                        bleActions.enableBack()
                    }
                }, 1050);
            }, 100);
        }else{
            const stop = makeMsg(4, 1, startStop, pairLeft)
            bleActions.sendMessage(stop)
            stopCount.value = 1

            // 무응답 시 추가
            const retryInterval = setInterval(() => {
                if(stopCount.value > 0){
                    const retry = makeMsg(4, 1, startStop, pairLeft)
                    bleActions.sendMessage(retry)
                }
            }, 200)
            setTimeout(() => {
                if (retryInterval) {
                    clearInterval(retryInterval);
                    bleActions.enableBack()
                }
            }, 1050);
        }
        count.value++
    }

    const waveFormMap = {
        "Sharp":        [10, 90, 0, 0],
        "Moderate":     [20, 80, 0, 0],
        "Triangle":     [50, 0, 50, 0],
        "Square":       [0, 50, 0, 50],
        "Sawtooth":     [100, 0, 0, 0],
        "Fast Ramp-Up": [0, 50, 50, 0],
        "Short-Pulse":  [0, 10, 0, 90],
        "Default-Wave": [25, 25, 25, 25]
    };

    function getWaveFormParams(waveForm) {
        const arr = waveFormMap[waveForm] || [0, 0, 0, 0];
        return {
            rampUp  : arr[0],
            peak    : arr[1],
            rampDown: arr[2],
            off     : arr[3]
        };
    }

    function recordMeasurementEvent(eventType, extraParams = {}, type) {
        const authStore = useAuthStore();

        const serializedParams = {};
        Object.keys(extraParams).forEach(key => {
            const value = extraParams[key];
            serializedParams[key] =
                (typeof value === 'object' || Array.isArray(value)) ? JSON.stringify(value) : value;
        });

        api.post(urls.patientList.recordEvent, {
            email: authStore.getUser?.email || 'unknown_user',
            deviceName: commonUtils.getDeviceInfo(),
            eventType,
            type,
            eventTime: new Date().toISOString(),
            ...serializedParams
        })
            .catch(err => {});
    }

    const handleNGReceived = () => {
        if (timerInterval) {
            clearInterval(timerInterval);
            timerInterval = null;
        }
        
        elapsedTimeMs.value      = 0;
        pairElapsedMs.value      = 0;
        currentExecIndex.value   = 0;
        currentRunningPair.value = null;

        // 완료 상태 초기화 (필요하면 선택적으로)
        treatmentTableLeft.value.forEach(item => {
            item.completed = false;
        });

        showAlert('비정상 수신 중입니다. 디바이스를 다시 확인해주세요.')
    }

    let padError = false

    const intervalArray = []

    const handleDataReceived = (event) => {
        const data = event.detail
        const type = 'R'

        ctrl1Count.value = 0
        ctrl2Count.value = 0
        startCount.value = 0
        stopCount.value  = 0

        // 임시 KTL 대응용
        const isStopPacket =
        data.length === 20 &&
        data[0] === 0x78 &&
        data[1] === 0x0A &&
        data[2] === 0x10 &&
        data[18] === 0x1A &&
        data[19] === 0x79 &&
        data.slice(3, 18).every(v => v === 0x00)

        if (isStopPacket) {
            pauseTimer();
        }
        // 임시 KTL 대응용

        if(data[2] == 0xaa || data[3] == 0xaa){
            if(!padError){
                if(data[2] == 0xaa){
                    const result = convertUtils.generateBLEArray(2, 0x55)
                    bleActions.sendMessage(result)
                    ch1Noraml.value = true
                }
                if(data[3] == 0xaa){
                    setTimeout(() => {
                        const result = convertUtils.generateBLEArray(3, 0x55)
                        bleActions.sendMessage(result)
                        ch2Noraml.value = true
                    }, 200);
                }
                
                // setTimeout(() => {
                //     const pad = data[2] == 0xaa ? '채널1 PAD' : '채널2 PAD'
                //     showAlert(pad + '가 빠졌습니다. 다시 연결해주시길 바랍니다.')
                //     recordMeasurementEvent('electroDeviceError',{ measurementValues: data },type)
                //     stopTimer()
                //     padError = true
                // }, 200)
            }
        }else{
            padError = false

            if(state.value == 'start'){
                bleActions.disableBack()
                if (count.value == 1) {
                    count.value++
                    return
                }

                if (count.value > 1) {
                    const start = convertUtils.generateBLEArray(4, 1, 1)
                    bleActions.sendMessage(start)
                    startCount.value = 1

                    // 무응답 시 추가
                    const retryInterval = setInterval(() => {
                        if(startCount.value > 0){
                            const retry = convertUtils.generateBLEArray(4, 1, 1)
                            bleActions.sendMessage(retry)
                        }
                    }, 200)
                    setTimeout(() => {
                        if (retryInterval) {
                            clearInterval(retryInterval);
                            bleActions.enableBack()
                        }
                    }, 1050);

                    count.value = 0
                } else {
                    // const maxTime = pair.value.t * 60 * 1000;

                    // if (timerInterval) {
                    //     clearInterval(timerInterval);
                    //     timerInterval = null;
                    // }
                    
                    // if (intervalArray && intervalArray.length > 0) {
                    //     intervalArray.forEach(id => clearInterval(id));
                    //     intervalArray.length = 0;
                    // }

                    // timerInterval = setInterval(() => {
                    //     pairElapsedMs.value += 1000;

                    //     if (pairElapsedMs.value >= maxTime) {
                    //         clearInterval(timerInterval);
                    //         timerInterval = null;

                    //         finishPair(currentRunningPair.value);

                    //         elapsedTimeMs.value += pairElapsedMs.value;  // 누적 시간에 더하기
                    //         pairElapsedMs.value = 0;

                    //         currentExecIndex.value++;
                    //         if (currentExecIndex.value < executionOrder.value.length) {
                    //             const stop = convertUtils.generateBLEArray(4, 1, 0)
                    //             bleActions.sendMessage(stop)
                    //             stopCount.value = 1

                    //             // 무응답 시 추가
                    //             const retryInterval = setInterval(() => {
                    //                 if(stopCount.value > 0){
                    //                     const retry = convertUtils.generateBLEArray(4, 1, 0)
                    //                     bleActions.sendMessage(retry)
                    //                 }
                    //             }, 200)
                    //             setTimeout(() => {
                    //                 if (retryInterval) {
                    //                     clearInterval(retryInterval);
                    //                     bleActions.enableBack()
                    //                 }
                    //             }, 1050);

                    //             setTimeout(() => {
                    //                 startTimerForCurrentPair();
                    //             }, 200);
                    //         } else {
                    //             stopTimer()

                    //             // if (timerInterval) {
                    //             //     clearInterval(timerInterval);
                    //             //     timerInterval = null;
                    //             // }
                    //             // if (intervalArray && intervalArray.length > 0) {
                    //             //     intervalArray.forEach(id => clearInterval(id));
                    //             //     intervalArray.length = 0;
                    //             // }

                    //             const psId = prescriptionId.value;
                    //             api.post(urls.patientList.count, { psId })
                    //                 .then(() => {
                    //                     // console.log('카운트 증가 성공');
                    //                 })
                    //                 .catch(err => {
                    //                     showAlert('카운트 증가 중 오류가 발생했습니다.');
                    //                 });

                    //             showAlert("실행이 완료되었습니다.")
                    //             setTimeout(() => {
                    //                 router.push({
                    //                     path: `/patientlist/prescriptionHistory/${route.params.patientId}`
                    //                 })
                    //             }, 300);
                    //         }
                    //     }
                    // }, 1000);
                    // intervalArray.push(timerInterval);
                    // recordMeasurementEvent('electroDeviceStart',{ measurementValues: data },type);
                    const maxTime = pair.value.t * 60 * 1000;

                    clearAllIntervals();

                    startSmoothProgressTimer(maxTime, () => {
                        finishPair(currentRunningPair.value);

                        elapsedTimeMs.value += maxTime;
                        pairElapsedMs.value = 0;
                        pairBaseElapsedMs = 0;

                        currentExecIndex.value++;

                        if (currentExecIndex.value < executionOrder.value.length) {
                            const stop = convertUtils.generateBLEArray(4, 1, 0)
                            bleActions.sendMessage(stop)
                            stopCount.value = 1

                            // 무응답 시 추가
                            const retryInterval = setInterval(() => {
                                if(stopCount.value > 0){
                                    const retry = convertUtils.generateBLEArray(4, 1, 0)
                                    bleActions.sendMessage(retry)
                                }
                            }, 200)

                            setTimeout(() => {
                                if (retryInterval) {
                                    clearInterval(retryInterval);
                                    bleActions.enableBack()
                                }
                            }, 1050);

                            setTimeout(() => {
                                startTimerForCurrentPair();
                            }, 200);
                        } else {
                            stopTimer()

                            const psId = prescriptionId.value;
                            api.post(urls.patientList.count, { psId })
                                .then(() => {
                                    // console.log('카운트 증가 성공');
                                })
                                .catch(err => {
                                    showAlert('카운트 증가 중 오류가 발생했습니다.');
                                });

                            showAlert("실행이 완료되었습니다.")
                            setTimeout(() => {
                                router.push({
                                    path: `/patientlist/prescriptionHistory/${route.params.patientId}`
                                })
                            }, 300);
                        }
                    });

                    recordMeasurementEvent('electroDeviceStart',{ measurementValues: data },type);
                }
                
            }else if(state.value == 'pause'){
                bleActions.enableBack()
                if((data[1] == 0x00 && data[2] == 0x00) || (data[1] == 0x00 && data[3] == 0x00)){
                    // pad 에러 해결
                    if(ch1Noraml.value){
                        const normal1 = convertUtils.generateBLEArray(2, 0x55)
                        bleActions.sendMessage(normal1)
                        ch1Noraml.value = false
                    }
                    if(ch2Noraml.value){
                        setTimeout(() => {
                            const normal2 = convertUtils.generateBLEArray(3, 0x55)
                            bleActions.sendMessage(normal2)
                            ch2Noraml.value = false
                        }, 200);
                    }
                }else{
                    count.value = 0
                    if (timerInterval) {
                        clearInterval(timerInterval);
                        timerInterval = null;
                    }
                    intervalArray.forEach(id => clearInterval(id));
                    intervalArray.length = 0;

                    recordMeasurementEvent('electroDevicePause',{ measurementValues: data },type);
                }
            }else if(state.value == 'stop'){
                bleActions.enableBack()
                if((data[1] == 0x00 && data[2] == 0x00) || (data[1] == 0x00 && data[3] == 0x00)){
                    if(ch1Noraml.value){
                        const normal1 = convertUtils.generateBLEArray(2, 0x55)
                        bleActions.sendMessage(normal1)
                        ch1Noraml.value = false
                    }
                    if(ch2Noraml.value){
                        setTimeout(() => {
                            const normal2 = convertUtils.generateBLEArray(3, 0x55)
                            bleActions.sendMessage(normal2)
                            ch2Noraml.value = false
                        }, 200);
                    }
                }else{
                    count.value = 0
                    if (timerInterval) {
                        clearInterval(timerInterval);
                        timerInterval = null;
                    }
                    elapsedTimeMs.value = 0;
                    pairElapsedMs.value = 0;
                    currentExecIndex.value = 0;
                    currentRunningPair.value = null;

                    // 완료 상태 초기화 (필요하면 선택적으로)
                    treatmentTableLeft.value.forEach(item => {
                        item.completed = false;
                    });
                    treatmentTableRight.value.forEach(item => {
                        item.completed = false;
                    });
                    recordMeasurementEvent('electroDeviceStop',{ measurementValues: data },type);
                }
            }
        }
    }

    const stopMsg = () => {
        if (state.value !== 'start') return
        if (!bleState.deviceConnected.value || !bleState.isReady.value) return

        clearAllIntervals()

        const result = convertUtils.generateBLEArray(4, 1, 0)
        bleActions.sendMessage(result)
        bleActions.enableBack()
        stopCount.value = 1

        state.value = 'pause'
        startFlag.value = ''
        count.value = 0

        window.dispatchEvent(new CustomEvent('prescription-running', { detail: { running: false } }))

        const retryInterval = setInterval(() => {
            if (stopCount.value > 0) {
                const retry = convertUtils.generateBLEArray(4, 1, 0)
                bleActions.sendMessage(retry)
            }
        }, 200)

        setTimeout(() => {
            clearInterval(retryInterval)
        }, 1050)
    }

    const handleNativeAppState = (event) => {
        const appState = event.detail?.state
        console.log('앱 상태:', appState)

        if (appState === 'background') {
            stopMsg()
        } else if (appState === 'foreground') {
            console.log('앱이 포그라운드로 복귀했습니다.')
        }
    }
    onMounted(() => {
        initializeVariables();  // 변수 초기화

        const idFromRoute = route.params.patientId;
        prescriptionId.value = route.query.prescriptionId; // 반응형 상태에 할당
        PatientData(idFromRoute, prescriptionId.value);
        fetchTreatmentData(idFromRoute, prescriptionId.value);

        window.addEventListener('ble-ng-received', handleNGReceived)
        window.addEventListener('ble-data-received', handleDataReceived)
        window.addEventListener('beforeunload', stopMsg)
        window.addEventListener('ble-disconnected', handleDisconnected)
        window.addEventListener('nativeAppState', handleNativeAppState)
        window.addEventListener('battery-status-changed', handleBatteryStatusChanged)
    })

    function initializeVariables() {

        if (intervalArray && intervalArray.length > 0) {
            intervalArray.forEach((id) => clearInterval(id)); // 모두 해제
        }

        cancelSmoothProgressTimer();

        intervalArray.length = 0;
        timerInterval        = null;
        state.value          = '';

        elapsedTimeMs.value      = 0;
        pairElapsedMs.value      = 0;
        currentExecIndex.value   = 0;
        currentRunningPair.value = null;
        executionOrder.value     = [];
        prescriptionId.value     = null;
        count.value              = 0;

        pairStartTimestamp = 0;
        pairBaseElapsedMs = 0;
    }

    onBeforeUnmount(() => {
        stopMsg()
        clearAllIntervals()

        window.removeEventListener('ble-ng-received', handleNGReceived)
        window.removeEventListener('ble-data-received', handleDataReceived)
        window.removeEventListener('beforeunload', stopMsg)
        window.removeEventListener('ble-disconnected', handleDisconnected)
        window.removeEventListener('nativeAppState', handleNativeAppState)
        window.removeEventListener('battery-status-changed', handleBatteryStatusChanged)

        window.dispatchEvent(new CustomEvent('prescription-running', { detail: { running: false } }))
    })
</script>